import { TFunction } from 'i18next';
import { formatNumber } from '@/utils/helpers';
import { PaymentMethod } from '@/api/types/payments.types';
import { UserCard } from '@/api/types/user.types';

export function getPaymentMethodLabel(
  t: TFunction,
  paymentMethod?: PaymentMethod,
  walletBalance?: number,
  isExtended = false
) {
  switch (paymentMethod) {
    case PaymentMethod.My_card:
    case PaymentMethod.Card:
      return t('pages.ad.bank_card');
    case PaymentMethod.Wallet:
      return walletBalance || walletBalance === 0
        ? t('pages.ad.private_account', {
            amount: formatNumber(walletBalance, 2),
          })
        : t('pages.cabinet.private_account');
    case PaymentMethod.Terminal:
    case PaymentMethod.Portmanat:
      if (!isExtended) return '';
      return t(
        paymentMethod === PaymentMethod.Terminal
          ? 'pages.ad.pay_in_terminals'
          : 'pages.ad.portmanat'
      );
    default:
      return '';
  }
}

export const getPaymentMethodsInfo = (
  t: TFunction,
  paymentMethods: PaymentMethod[],
  walletBalance?: number
) => {
  return paymentMethods
    .filter(paymentMethod => paymentMethod !== PaymentMethod.My_card)
    .map(paymentMethod => ({
      label: getPaymentMethodLabel(t, paymentMethod, walletBalance, true),
      value: paymentMethod,
    }));
};

export function getCardSystemLogo(card: UserCard) {
  switch (card.paymentSystem) {
    case 'Visa':
      return 'visa';
    case 'MasterCard':
      return 'mastercard';
    default:
      return '';
  }
}
